$(document).ready(function() {
    (function($) {
        $.fn.textfill = function(options) {
            let fontSize = options.maxFontPixels;
            let ourText = $(this).find('.article__sku');
            let maxHeight = $(this).height();
            let maxWidth = $(this).width();
            let textHeight;
            let textWidth;
            do {
                ourText.css('font-size', fontSize);
                textHeight = parseInt( ourText.css('height') );
                textWidth = parseInt( ourText.css('width') )
                fontSize = fontSize - 1;
            } while ( textHeight > maxHeight || textWidth > maxWidth );
            return this;
        }

        $.fn.textfillPrice = function(options) {
            let fontSize = options.maxFontPixels;
            let ourText = $(this).find('.price__number');
            let ourPrice = $(this).find('.price__currency');
            let maxHeight = $(this).height();
            let maxWidth = $(this).width();
            let textHeight;
            let textWidth;
            do {
                ourText.css('font-size', fontSize);
                textHeight = parseInt( ourText.css('height') );
                textWidth = parseInt( ourText.css('width') ) + parseInt( ourPrice.css('width') ) + 10;
                fontSize = fontSize - 1;
            } while ( textHeight > maxHeight || textWidth > maxWidth );
            return this;
        }

    })(jQuery);

    $('.article .products__column:nth-of-type(3)').each(function() {
        $(this).textfill({ maxFontPixels: 14 });
    })

    $('.price.article__price').each(function() {
        $(this).textfillPrice({ maxFontPixels: 18 });
    })


});

$(document).ajaxComplete(function( ) {
    $('.article .products__column:nth-of-type(3)').each(function() {
        $(this).textfill({ maxFontPixels: 14 });
    })

    $('.price.article__price').each(function() {
        $(this).textfillPrice({ maxFontPixels: 18 });
    })
});
$(window).on('load', function( ) {
    $('.article .products__column:nth-of-type(3)').each(function() {
        $(this).textfill({ maxFontPixels: 14 });
    })

    $('.price.article__price').each(function() {
        $(this).textfillPrice({ maxFontPixels: 18 });
    })
    setTimeout(function() {
        $('.article .products__column:nth-of-type(3)').each(function() {
            $(this).textfill({ maxFontPixels: 14 });
        })

        $('.price.article__price').each(function() {
            $(this).textfillPrice({ maxFontPixels: 18 });
        })
    }, 1000)

});


// WEBPACK FOOTER //
// ./src/js/components/fillTextToDiv.js